export default __webpack_public_path__ + "5f1d731ae4c7b6497ba2f40052be396a.mp3";